<template>
  <div>
    <HeaderBg :title="$t('adminHomePageSlider.title')" />

    <div class="form_container">
      <form @submit.prevent="addHome">
        
        <!-- Loop over slider images -->
        <div
          class="upload_img"
          v-for="(item, index) in slider"
          :key="index"
        >
          <span>{{$t('adminHomePageSlider.imageLabel')}} {{ index + 1 }}</span>
          <div class="img_container">
            <img
              src="../../../assets/images/replaceImg.svg"
              alt=""
              v-if="!item.preview"
            />
            <img
              :src="item.preview"
              alt=""
              v-else
            />
            <div class="photo_upload">
              <div class="upladImg">
                <div class="upload">
                  <label>
                    <img src="../../../assets/images/inputFile.svg" alt="">
                    <input
                      type="file"
                      @change="uploadImage($event, index)"
                    >
                  </label>
                </div>
              </div>
            </div>
            <!-- Delete button -->
            
          </div>
          <button 
              type="button" 
              class="deleteBtn" 
              @click="deleteImage(item.id, index)"
            >
               {{$t('adminHomePageSlider.delete')}}
            </button>
        </div>

        <!-- Add new upload button -->
         <div>
            <button type="button" class="addMoreBtn" @click="addUpload">
            {{$t('adminHomePageSlider.addMore')}}
            </button>
        </div>
        <div class="alert alert-success mt-2" role="alert" v-if="successMessage">
          {{$t('adminHomePageSlider.successMessage')}}
        </div>
        <div class="alert alert-danger mt-2" role="alert" v-if="ErrorCheck">
          <p v-for="(error, index) in errors" :key="index"> {{ error }} </p>
        </div>

        <!-- Save Button -->
        <button class="saveBtn" v-if="!postLoaded">
          {{$t('adminHomePageSlider.save')}}
        </button>
        <button class="saveBtn" v-if="postLoaded">
          <b-spinner></b-spinner>
        </button>
      </form>
    </div>
  </div>
</template>

<script>
import HeaderBg from '../../global/HeaderBg/HeaderBg';
import axios from 'axios';
import Request from '../../../services/Request';
export default {
  name: 'HomePageSlider',
  components: { HeaderBg },
  data() {
    return {
      postLoaded: false,
      successMessage: false,
      slider: [
        { image: '', preview: '', id:'' }
      ],
      errors: [],
      ErrorCheck: false,
    }
  },
  mounted(){
    this.getSliderImages();
  },
  methods: {
    // Add new upload field
    addUpload() {
      this.slider.push({ image: '', preview: '' });
    },

    // Handle file upload
    uploadImage(event, index) {
      const file = event.target.files[0];
      if (file) {
        this.slider[index].image = file;
        this.slider[index].preview = URL.createObjectURL(file);
      }
    },

    addHome() {
      this.successMessage = false;
      this.postLoaded = true;
      this.errors = [];
      this.ErrorCheck = false;

      const formData = new FormData();

      // Append uploaded images
      this.slider.forEach((item, index) => {
        if (item.image) {
          formData.append(`images[${index}]`, item.image);
        }
      });

      // Example post request
      axios.post("https://app.almujtama.com.sa/admin/home_page_slider", formData, {
          headers: { 
              Authorization: `Bearer ${localStorage.getItem("token")}`,
              "Content-Type": "multipart/form-data"
          }
      })
      .then(() => {
          this.postLoaded = false;
          this.ErrorCheck = false;
          this.successMessage = true;
      })
      .catch(err => {
          if (err.response && err.response.data && err.response.data.errors) {
              this.errors = err.response.data.errors;
              this.ErrorCheck = true;
          }
          this.postLoaded = false;
      });
    },
     // Delete image (by ID if exists, else just local)
  deleteImage(id, index) {
      axios.delete(`https://app.almujtama.com.sa/admin/home_page_slider/${id}`, {
        headers: { 
          Authorization: `Bearer ${localStorage.getItem("token")}`
        }
      })
      .then(() => {
        this.slider.splice(index, 1);
      })
      .catch(err => {
        console.error("Delete failed", err);
      });
  },
    getSliderImages() {
      Request.fetch(`admin/home_page_slider`, '')
        .then((response) => {
          this.slider = []
          response.data.data.forEach((item) => {
            
            this.slider.push({
              image: '',
              preview: item.path,
              id: item.id
            });
          });
        })
        .catch(err => {
          if (Request.statusIsFaield(err)) {
            this.$router.push('/login');
            localStorage.removeItem('token');
          }
        });
    }

  }
}
</script>

<style lang="scss" scoped>
.addMoreBtn{
    border: 0;
    background-color: #656565;
    color: #FFF;
    display: inline-block;
    padding: 10px 10px;
    border-radius: 4px;
    font-size: 16px;
    margin-right: 20px;
}
.deleteBtn{
    border: 0;
    background-color: rgba(255, 0, 0, 0.667);
    color: #FFF;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 10px 10px;
    border-radius: 4px;
    font-size: 12px;
    margin-right: 20px;
}
.form_container{
    background-color: #FFF;
    border-radius: 10px;
    margin: 40px auto;
    padding: 70px 100px;
    @media (max-width: 576px) {
        width: 97%;
        padding: 30px;
    }
    form{
        > div{
            margin-bottom: 40px;
            label{
                display: block;
                text-align: center;
                font-size: 16px;
                color: #717171;
                font-weight: 600;
                margin-bottom: 10px;
            }
            input{
                border: 1px solid #71717191;
                font-size: 16px;
                padding: 5px 10px;
                border-radius: 10px;
                display: block;
                margin: auto;
                width: 50%;
            }
        }
    }
}
.upload_img{
            display: flex;
            align-items: center;
            margin-bottom: 40px;
            width: 100%;
            span{
                font-size: 16px;
                color: #656565;
                margin-inline-end: 50px;
            }
            .img_container{
                width: 80px;
                height: 80px;
                border-radius: 50%;
                background-color: #FAFAFA;
                display: flex;
                justify-content: center;
                align-items: center;
                position: relative;
                img{
                    width: 100%;
                }
                .photo_upload{
                    
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    position: absolute;
                    bottom: 0;
                    right: 0;
                    img{
                        width: 70%;
                    }
                }
            }
        }
</style>